// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1xw2q","top":"styles_top__3OxV2","left":"styles_left__1P_bo","description":"styles_description__pGCqh"};